import { render, staticRenderFns } from "./unassignedRecord.vue?vue&type=template&id=1ca9bce1&scoped=true"
import script from "./unassignedRecord.vue?vue&type=script&lang=js"
export * from "./unassignedRecord.vue?vue&type=script&lang=js"
import style0 from "./unassignedRecord.vue?vue&type=style&index=0&id=1ca9bce1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca9bce1",
  null
  
)

export default component.exports